import { render, staticRenderFns } from "./newMiscellTable.vue?vue&type=template&id=35873437&"
import script from "./newMiscellTable.vue?vue&type=script&lang=js&"
export * from "./newMiscellTable.vue?vue&type=script&lang=js&"
import style0 from "./newMiscellTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports